/* eslint-disable max-lines-per-function */
import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";

const $getModalColor = () =>
  document.querySelector(".js-product-details-notify-on-restock-modal-color");
const $getProductDetailsForm = () => document.getElementById("product-details-variants-form");
const $getVariantInputs = activeColor =>
  $getProductDetailsForm()?.querySelectorAll(`input[data-color="${CSS.escape(activeColor)}"]`);

export const trackRestockBtn = (event, activeColor) => {
  const $variantInputs = $getVariantInputs(activeColor);
  if (!$variantInputs?.[0]) return;

  const { brandName, detailedProductName, compositionId, color, businessLine } =
    $variantInputs[0].dataset;
  const inStock = [];
  const outOfStock = [];

  $variantInputs.forEach($input => {
    const { size } = $input.dataset;
    if ($input.disabled) {
      outOfStock.push(size);
    } else {
      inStock.push(size);
    }
  });

  track(event, {
    brand: brandName,
    product: detailedProductName,
    spree_composition_id: compositionId,
    composition: color,
    sizes_out_of_stock: outOfStock,
    sizes_in_stock: inStock,
    page_name: "product_detail",
    business_line: businessLine
  });
};

const trackRestockModalClicks = (event, action, extraData) => {
  const $modalColor = $getModalColor();
  if (!$modalColor) return;

  const activeColor = $modalColor.innerHTML.trim().replace("Color: ", "");
  const $variantInputs = $getVariantInputs(activeColor);
  if (!$variantInputs?.[0]) return;

  const { brandName, detailedProductName, compositionId, color, businessLine } =
    $variantInputs[0].dataset;

  track(event, {
    ...extraData,
    brand: brandName,
    product: detailedProductName,
    spree_composition_id: compositionId,
    composition: color,
    action,
    business_line: businessLine
  });
};

export const modalClicksTracker = (action, extraData = {}) => {
  trackRestockModalClicks("notify_on_restock_modal_clicks", action, extraData);
};

export const sizeClicksTracker = (action, extraData = {}) => {
  trackRestockModalClicks("notify_on_restock_sizes_clicks", action, extraData);
};

const modalClicksListeners = (action, className) => {
  const callback = () => {
    modalClicksTracker(action);
  };

  onEvent("click", className, callback, true);
};

export default () => {
  modalClicksListeners("go_to_your_favorites", ".js-restock-modal-to-favorites-link");
};
